module.exports = __webpack_public_path__ + "static/media/1-9.7cfe60de.svg";